export default __webpack_public_path__ + "static/media/btn-add-to-teams.8c02fed3.svg";